<template>
  <div class="row pl-2 pr-2 pb-2 pt-2">
    <div class="col-12">
      <h4>{{ $t('filter.summary') }}</h4>
      <div class="bg-darker pl-2 pt-1 pb-1 border-radius">
        <filter-display
            class="mb-2"
            v-if="content"
            :content="content"
        />
      </div>

      <info-panel
          v-if="$store.getters.isSuperAdmin"
          :collapsible="true"
          :initially-collapsed="true"
          class="border-panel small-header smaller-title new-style mt-3"
          info-panel-header="SourceCode"
          preview-id="something">
        <div slot="info">
          <pre>{{ content }}</pre>
        </div>
      </info-panel>

      <hr />

      <h4>{{ $t('filter.startSettings') }}</h4>
      <info-panel
          :collapsible="true"
          :initially-collapsed="true"
          class="border-panel light-header smaller-title small-header new-style"
          info-panel-header="AdvancedFeatures"
          preview-id="something">
        <div slot="info" class="bg-highlight d-inline-block p-2 mb-3 border-radius">
          <icon type="exclamation-triangle"/>
          {{ $t('keepOriginalNamesAlert') }}
        </div>
        <div slot="info" class="form-group">
          <input id="checkbox" ref="checkbox" v-model="renaming" class="checkbox float-left mr-2"
                 type="checkbox">
          <div class="ml-4 inline-edit-label" for="checkbox">{{ $t('keepOriginalNames') }}</div>
        </div>
      </info-panel>

      <div class="vform-label white medium mt-1 d-inline-block">{{ $t('email') }}</div>
      <info-helper class="ml-1 d-inline-block" text="stepEmailDisclaimer"/>
      <input v-model="email"
             :class="['form-text form-text-dark w-100 mb-3', $v.email.$error ? 'form-group--error' : '']"
             type="text"
             @blur="$v.email.$touch"
      >
      <div v-if="!$v.email.email" class="form-error mb-2 border-radius">{{ $t('errors.mustBeAValidEmailAdress') }}</div>

      <div class="vform-label white medium mb-0 pb-0 mt-3">{{ $t('selectVM') }}</div>
      <vm-selector
          custom-classes="darker"
          class="d-block"
          :show-prices="$store.getters.isSuperAdmin"
          @selected="setVM"/>
      <div v-if="error"
           class="form-error mt-2 col-12 col-md-6 border-radius">
        {{ error }}
      </div>
    </div>
    <div v-if="!processing" class="col-12 mt-3">
      <div
          class="settings-button d-inline-block switched-colors"
          @click="$emit('abort')">{{ $t('abort') }}
        <icon class="ml-3" type="xmark"/>
      </div>
      <div
          class="settings-button d-inline-block icon-rotate-animation make-longer-animation ml-3 switched-colors"
          @click="triggerVersionProcess">
        {{ $t('start') }}
        <icon class="ml-3" type="cube"/>
      </div>
    </div>
    <div v-if="processing" class="col-12 mt-1">
      <loading-panel :time-in-seconds="0" message="pleaseWait"/>
    </div>
  </div>
</template>

<script>
import LoadingPanel from "@/components/LoadingPanel";
import Icon from "../Icon";
import InfoPanel from "@/components/InfoPanel";
import {email} from "vuelidate/lib/validators";
import InfoHelper from "@/components/InfoHelper";
import vmSelector from "@/components/vmSelector";
import FilterDisplay from "../exportProfiles/FilterDisplay";
export default {
  name: "FilterTriggerForm",
  components: {
    LoadingPanel,
    Icon,
    InfoPanel,
    InfoHelper,
    vmSelector,
    FilterDisplay
  },
  props: {
    /*
    * @param filterItem {Object} a filter-instance, needs to contain the asset as an include
    * */
    filterItem: {type: Object, required: true},
    projectId: {type: String, required: true},
    rootNode: {type: String, required: true},
    instanceId: {type: String, default: ""},
    inputUnits: {type: String, default: null}
  },
  data() {
    return {
      assetContent: {},
      content: {},
      mode: 'exclude',
      error: '',
      processing: false,
      email: this.$store.getters.getUserEmail(),
      renaming: false,
      vm: '',
    };
  },
  validations: {
    email: {
      email,
    },
  },
  beforeMount() {
    this.assetContent = this.filterItem.content ? JSON.parse(this.filterItem.content) : {};
    this.content = this.assetContent;
  },
  methods: {
    setVM(id) {
      this.vm = id;
    },
    async getLodFiles() {
      return await this.$store.dispatch('loadInstanceFiles', {id: this.rootNode})
          .then(files => {
            const fbx = files.filter(item => {
              return item.key.includes('.fbx') && item.key !== 'skel.fbx'
            });
            let res = [];
            if (fbx.length) {
              res = fbx.map(item => {
                return `${this.rootNode}/${item.key}`;
              });
            }
            return res;
          })
    },
    async deleteCache() {
      await this.$store.dispatch('clientDeleteAssemblyProjectInstancesCaching', { id: this.projectId });
      this.$store.dispatch('createNotification', {
        text: 'Cache deleted',
      })
      console.log('cache deleted');
    },
    async triggerVersionProcess() {
      this.processing = true;
      const files = await this.getLodFiles();
      // eslint-disable-next-line no-unreachable
      if (!this.rootNode) {
        this.error = this.$t('errors.rootNodeNotFound');
      }
      const {pipeline, mode, filter, filterStringArray, merge, mergeStringArray, filterIdArray, mergeIdArray} = this.content;
      const {axisMultiplier, pivotMetaSetId, pivotPlacement, pivotField} = pipeline;
      let config = {
        axisMultiplier,
        pivotPlacement,
        pivotField,
        pivotMetaSetId,
        mode,
        filter,
        filterStringArray,
        merge,
        mergeStringArray,
        filterIdArray,
        mergeIdArray,
        sendMails: true,
        email: this.email ? this.email : this.$store.getters.getUserEmail(this.$store.getters.getCurrentUserId),
        lang: this.$i18n.locale ? this.$i18n.locale : 'en',
        files: files,
        rootNodeId: this.rootNode,
        renaming: this.renaming,
        outputFormats: ['fbx', 'glb'],
        inputUnits: this.inputUnits
      };
      // legacy fix
      if (!config.mode) {
        config.mode = this.content.pipeline.subVersion.mode;
      }
      const method = this.instanceId ? 'updateFilterInstance' : 'createFilterInstance';
      const fixedContent = JSON.stringify({
        ...this.content,
        ...config
      });
      let args = {
        id: this.projectId,
        name: this.filterItem.name + '_export',
        args: [{
          assetId: this.filterItem.id,
          content: fixedContent,
          state: 'p',
        }]
      }
      if (this.instanceId) {
        args.cid = this.instanceId;
        args.content = fixedContent;
      }
      await this.$store.dispatch(method, args)
          .then(async instance => {
            if (instance) {
              await this.deleteCache();
              const selected = instance[0] ? instance[0] : instance;
              await this.$store.dispatch('clientInstanceToPipeline', {
                id: selected.id,
                type: 'filter',
                virtualMachine: this.vm,
                config: JSON.stringify(config)
              }).then(() => {
                this.processing = false;
                this.$emit('started');
              }).catch(e => {
                this.error = e.response.errors.message;
                this.processing = false;
              });
            }
          });
    },
  }
}
</script>

<style scoped>
pre {
  color: #fff;
  word-break: break-all;
}
.bg-darker {
  background-color: var(--vform-editor-ui-quinary-color);
}
hr {
  border-color: rgba(255, 255, 255, 0.2);
}
</style>